<template>
    <v-btn id="show-split-view-button"
           ref="show-split-view-button"
           v-tippy
           content="Split View"
           :disabled="isDisabled"
           @click="onClick"
    >

        <v-icon class="material-icons">compare</v-icon>
    </v-btn>

</template>

<script>
import { mapState } from "vuex";

export default {
    mounted() {
        this.$root.$refs.showSplitViewButton = this.$refs['show-split-view-button'];
    },

    computed: {
        ...mapState('Projects', ['image']),
        isDisabled() {
            return !this.image;
        }
    },

    methods: {
        onClick() {
            if (this.isDisabled) return;

            if (!window.lutify.splitViewActive) {
                window.lutify.splitSlider = 0.5;
                window.lutify.setSplitView();
            } else {
                window.lutify.removeSplitView();
                window.lutify.splitSlider = 0.5;
            }
        }
    }
}
</script>